import { render, staticRenderFns } from "./OrderShipmentsOthers.vue?vue&type=template&id=645f2b1c&scoped=true&"
import script from "./OrderShipmentsOthers.vue?vue&type=script&lang=js&"
export * from "./OrderShipmentsOthers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645f2b1c",
  null
  
)

export default component.exports